import { apiClient } from '@/shared/api';
import { buildQueryString } from '@/shared/utils/buildQueryString';
import type { Result } from '@/shared/types';
import type { ApiError } from '@/shared/types/errors';
import type { HistoryItem, HistoryListResponse, HistoryStats } from './types';

export async function fetchHistory(
  limit: number = 20,
  offset: number = 0,
  status?: string,
): Promise<Result<HistoryListResponse, ApiError>> {
  return apiClient.get<HistoryListResponse>(`/api/history${buildQueryString({ limit, offset, status })}`);
}

export async function fetchHistoryItem(
  generationId: string,
): Promise<Result<HistoryItem, ApiError>> {
  return apiClient.get<HistoryItem>(`/api/history/${generationId}`);
}

export async function fetchHistoryStats(): Promise<Result<HistoryStats, ApiError>> {
  return apiClient.get<HistoryStats>('/api/history/stats');
}

export async function deleteGeneration(
  generationId: string,
): Promise<Result<void, ApiError>> {
  return apiClient.delete<void>(`/api/history/${generationId}`);
}

export function getImageUrl(generationId: string): string {
  const baseUrl = import.meta.env['VITE_API_BASE_URL'] ?? '';
  return `${baseUrl}/api/history/${generationId}/image`;
}
